// extracted by mini-css-extract-plugin
export default {"statistic":"ContentfulStatistics-module__statistic--WB8z1"};